
<i class="fa fa-lg fa-check-circle content-list-item-icon mr-2" :class="{ active: isRead }"></i>
